import Link from '@/components/Link';
import clsx from 'clsx';

export default function PostListing({ uri, title, excerpt, featuredImage }) {
  return (
    <Link
      href={uri}
      className="relative flex w-full transition duration-200 ease-in-out rounded-lg lg:rounded-xl xl:rounded-2xl"
    >
      {({ isHovering }) => (
        <>
          <div className="relative z-10 flex flex-col w-full">
            <div
              className="w-full h-0 overflow-hidden bg-gray-100 bg-center bg-cover rounded-t-lg h-50 transition-cpu lg:rounded-t-xl xl:rounded-t-2xl"
              style={{
                paddingTop: 'calc((9% / 16) * 100)',
                transition:
                  'clip-path 0.25s ease-in-out,-webkit-clip-path 0.25s ease-in-out',
                clipPath: isHovering
                  ? 'inset(0% 0% 0 0% round 12px 12px 0px 0px)'
                  : 'inset(8% 4% 0 4% round 12px 12px 12px 12px)',
                backgroundImage: `url('${featuredImage?.node?.sourceUrl}')`,
              }}
            />
            <div className="flex flex-col px-8 py-8 space-y-2 rounded-b-lg lg:space-y-4 lg:rounded-b-xl xl:rounded-b-2xl">
              <h2 className="text-lg font-medium">{title}</h2>
              <div className="relative overflow-hidden lg:h-20 xl:h-28">
                <div
                  className="font-normal prose"
                  dangerouslySetInnerHTML={{ __html: excerpt }}
                />
                <div className="absolute bottom-0 left-0 right-0 w-full h-10 bg-gradient-to-t from-gray-100 to-transparent" />
                <div
                  className={clsx(
                    'absolute bottom-0 left-0 right-0 h-10 w-full bg-gradient-to-t from-white to-transparent transition duration-200 ease-in-out',
                    isHovering === false && 'opacity-0',
                    isHovering === true && 'opacity-100'
                  )}
                />
              </div>
            </div>
          </div>
          <div
            className="absolute inset-0 z-0 transform bg-white rounded-lg shadow-xl transition-cpu lg:rounded-xl xl:rounded-2xl"
            style={{
              opacity: isHovering ? '1' : '0',
              transition:
                'transform 0.31s ease-in-out,opacity .17s ease-in-out',
              transform: isHovering ? 'scale(1)' : 'scale(.92)',
            }}
          />
        </>
      )}
    </Link>
  );
}
